<template>
<div>
<v-row>
    <v-col class="text-center">
        <v-btn class="primary rounded" to="/">Retour en page d'accueil</v-btn>
    </v-col>
    <v-col class="text-center">
        <v-btn class="primary rounded" @click="goBack">Retour en page prédédente</v-btn>
    </v-col>
</v-row>


</div>   


</template>



<script>

    export default {
        name : 'NotFound',

        data: function() {

            return {
            }
        },

        methods :  {

            goBack() {
                this.$router.go(-1)
            }
        },
        mounted() {

        },

        created() {

            // on met ca ici car hors connexion, c'est le composant par défaut si rien n'est trouvé
            
            if(localStorage.getItem("tokenMinu")==null) {

                const quer =  (this.$route.fullPath!='/') ? { redirect: this.$route.fullPath } : {};
                this.$router.push({path:'/login',query:quer}).catch(() => {})
            } 

        }

    }

</script>